// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getMessaging } from "firebase/messaging";
import { getMessaging, onBackgroundMessage } from 'firebase/messaging/sw';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDrGyIXwixEr9bKVTSW8X-t4bZv0cDIaYw",
    authDomain: "sekerondevapp.firebaseapp.com",
    projectId: "sekerondevapp",
    storageBucket: "sekerondevapp.appspot.com",
    messagingSenderId: "311387859235",
    appId: "1:311387859235:web:81fcb14733658e78f20496",
    measurementId: "G-5K18Z43LNK"
  };
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging and get a reference to the service
const messaging = getMessaging(app);

export { messaging };
